export const LOCAL_STORAGE_TTL = 60 * 60 * 24 * 10; // 10 days
